define('rebrush/components/layout/page/switch/storeview',[
	'cartware/components/_base',
	'jquery',
	'lodash',
	'cartware/jquery/bem',
	'rebrush/system/layout/responsive-hub',
	'text!shoptheme/templates/magnific-popup/storeswitch.html',
	'bootstrap-popover'
], function(
	Component,
	$,
	_,
	BEM,
	ResponsiveHub,
	PopupHtml
) {
	var isMobile = true;

	return Component.create({
		block:				null,
		popoverTrigger:		null,
		popoverWrap:		null,
		popoverContainer:	null,
		storeGroupSelect:	null,
		currentGroup:		null,
		newGroup:			null,
		storeViewContainer:	null,
		storeViewSelects:	null,
		currentView:		null,
		currentViewIndex:	null,
		popup: 				null,
		popupAcceptBtn:		null,

		$init: function() {
			var self = this,
				url = null,
				storeGroup = null;

			this.block = BEM.block('page-switch');
			this.popupAcceptBtn = $('.storeswitch-accept');

			this.popoverTrigger = this.block.getElements('popover-trigger');
			this.popoverWrap = this.block.getElements('popover');
			this.popoverContainer = this.block.find('.' + BEM.buildBlockClassname('page-switch-popover'));

			this.storeGroupSelect = this.popoverContainer.find('.' + BEM.buildElementClassname('select', 'storegroup-select'));
			this.storeViewContainer = this.popoverContainer.bemGetElements('storeview-container');
			this.storeViewSelects = this.popoverContainer.find('.' + BEM.buildElementClassname('select', 'storeview-select'));
			this.currentGroup = this.storeGroupSelect.val();

			storeGroup = this.currentGroup;

			ResponsiveHub
				.on('change.mobile.enter', function() { isMobile = true; })
				.on('change.mobile.leave', function() { isMobile = false; });

			this.popoverTrigger.popover({
				content: function() {
					return self.popoverContainer;
				},
				template: '<div class="popover popover-servicemenu" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>',
				html: true,
				placement: function() {
					return isMobile ? 'top' : 'bottom';
				}
			});

			this.storeGroupSelect.on('change', function() {
				var select = $(this);
				storeGroup = select.val();
				var	activeStoreViewContainer = self.storeViewContainer.filter('[data-store-group="' + storeGroup + '"]'),
					options = activeStoreViewContainer.find('option').filter(function() { return $(this).prop('value'); }),
					itemCount = $('.btn-mini-cart span').text();

				if (options.length === 1) {
					if (itemCount > 0) {
						$.magnificPopup.open({
							items: {
								src: self._renderPopup({
									url: options.prop('value'),
									title: Translator.translate('Notice'),
									body: Translator.translate('Changing the country will empty your shopping cart.'),
									cancel: Translator.translate('Cancel'),
									proceed: Translator.translate('Proceed')
								})
							},
							callbacks: {
								open: function () {
									self.popoverTrigger.popover('hide');
									self.storeViewContainer.bemRemoveModifier('active');
								}
							}
						});
					} else {
						self.storeViewContainer.bemRemoveModifier('active');
						document.location.href = options.prop('value');
						return;
					}
				}

				self.storeViewContainer.bemRemoveModifier('active');
				activeStoreViewContainer.bemAddModifier('active');

				self.storeViewSelects.each(function() {
					$(this).data('select2').val(-1);
				});
			});

			this.storeViewSelects.on('change', function(e) {
				var url = $(this).val();
				var itemCount = $('.btn-mini-cart span').text(),
					view = $(this);

				if (null === url || '' === url) {
					return false;
				}

				if (itemCount > 0 && storeGroup != self.currentGroup) {
					$.magnificPopup.open({
						items: {
							src: self._renderPopup({
								url: url,
								title: Translator.translate('Notice'),
								body: Translator.translate('Changing the country will empty your shopping cart.'),
								cancel: Translator.translate('Cancel'),
								proceed: Translator.translate('Proceed')
							})
						},
						callbacks: {
							open: function () {
								self.popoverTrigger.popover('hide');
								view[0].selectedIndex = 0;

								$.magnificPopup.instance.close = function () {
									// Call the original close method to close the popup
									$.magnificPopup.proto.close.call(this);
								};
							}
						}
					});
				} else {
					document.location.href = url;
				}
			});
		},

		_renderPopup: function(data) {
			if (null === this.popup) {
				this.popup = _.template(PopupHtml);
			}

			return this.popup(data);
		}
	});
});
